"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.popupWindowBorder = exports.popupSupported = exports.isSafari = exports.gerWindowBorder = void 0;
const bowser_1 = __importDefault(require("bowser"));
const browser = bowser_1.default.getParser(window.navigator.userAgent);
function gerWindowBorder() {
    switch (browser.getOSName(true)) {
        case 'windows': {
            let result;
            switch (browser.getBrowserName(true)) {
                case 'firefox':
                    result = [68, 8, 8];
                    break;
                case 'microsoft edge':
                    result = [62, 8, 8];
                    break;
                //case 'chrome':
                default:
                    result = [60, 8, 8];
            }
            if (window.devicePixelRatio > 1) {
                result[0] -= 2;
                result[1] -= 1;
                result[2] -= 1;
            }
            return result;
        }
        case 'macos': {
            switch (browser.getBrowserName(true)) {
                case 'safari':
                    return [22, 0, 0];
                case 'firefox':
                    return [59, 0, 0];
                //case 'chrome':
                default:
                    return [51, 0, 0];
            }
        }
    }
    return [60, 8, 8];
}
exports.gerWindowBorder = gerWindowBorder;
exports.isSafari = browser.getBrowserName(true) === 'safari';
exports.popupSupported = browser.getPlatformType() === 'desktop';
exports.popupWindowBorder = gerWindowBorder();
